import React, {useContext} from 'react';
import {Navigate, Outlet} from 'react-router';
import {HOME_ROUTE} from '../../util/constants';
import {AppContext} from '../context/appContext';

export default function AdminController() {
    const context = useContext(AppContext);
    if (!context.userContext.user) return <Navigate to={HOME_ROUTE}/>;

    return <Outlet/>
}